import Parse from 'html-react-parser';

function BMP20130(props) {
    let svgCode =
    `<svg width="80" height="180" viewBox="0 0 80 180" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="38" height="60" fill="${props.darkFill}"/>
        <rect x="42" y="120" width="38" height="60" fill="${props.darkFill}"/>
        <path d="M24 23L16 31.5L24 40M16 31.5L24 40" stroke="${props.highlightColour}" stroke-width="5"/>
        <path d="M24 83L16 91.5L24 100M16 91.5L24 100" stroke="white" stroke-width="5"/>
        <path d="M24 143L16 151.5L24 160M16 151.5L24 160" stroke="white" stroke-width="5"/>
        <path d="M57 160L65 151.5L57 143M65 151.5L57 143" stroke="${props.highlightColour}" stroke-width="5"/>
        <path d="M57 100L65 91.5L57 83M65 91.5L57 83" stroke="white" stroke-width="5"/>
        <path d="M57 40L65 31.5L57 23M65 31.5L57 23" stroke="white" stroke-width="5"/>
    </svg>`

    props.svgReturn(50, svgCode, "bmp00130", 80, 180);

    const style = {
        position: "absolute",
        overflow: "hidden",
        height: "60px",
        top: "2px",
        left: "1360px",
        display: props.display
    }

    const inStyle = {
        marginTop: "0px"
    }

    return (
        <div style={style}>
            <div style={inStyle}>
            {Parse(svgCode)}
            </div>
        </div>
    );
}

export default BMP20130;